import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    id: "",
    quantity: 0,
    groupId: "",
    groupName: "",
    organizationId: "",
    hubs: [],
   updating: false,
   groupsWithHubs: [],
};

const hubSlice = createSlice({
  name: 'hubManagementSlice',
  initialState,
  reducers: {
    resetFilterState: (state) => {
      Object.assign(state, initialState);
    },
    setGroup: (state, action) => {
        const { name, id } = action.payload;
        state.groupName = name;
        state.groupId = id;
    },
    setUpdatingHub: (state, action) => {
        return { ...state, ...action.payload, updating: true };
    },
    setGroupsWithHubs: (state, action) => {
        state.groupsWithHubs = action.payload;
    },
    resetHubState: (state) => {
        return { ...initialState, groupsWithHubs: state.groupsWithHubs };
    },
  },
});

export const {
  resetFilterState,
  setGroup,
  setUpdatingHub,
  setGroupsWithHubs,
  resetHubState,
} = hubSlice.actions;

export default hubSlice.reducer;
